export var VouchedErrorType;
(function (VouchedErrorType) {
    VouchedErrorType["LivenessSkippedError"] = "LivenessSkippedError";
})(VouchedErrorType || (VouchedErrorType = {}));
export const isJobValid = (job) => {
    return (job.result.success &&
        (job.errors.length === 0 ||
            (job.errors.length === 1 && job.errors[0].type === VouchedErrorType.LivenessSkippedError)));
};
